export const VAS_LOADING = 'VAS_LOADING';
export const VAS_LOADED = 'VAS_LOADED';
export const VAS_LOAD_ERROR = 'VAS_LOAD_ERROR';
export const VAS_ANTIVIRUS_LOADING = 'VAS_ANTIVIRUS_LOADING';
export const VAS_ANTIVIRUS_LOADED = 'VAS_ANTIVIRUS_LOADED';
export const VAS_ANTIVIRUS_LOAD_ERROR = 'VAS_ANTIVIRUS_LOAD_ERROR';
export const VAS_SUBSCRIPTIONS_LOADING = 'VAS_ALL_LOADING';
export const VAS_SUBSCRIPTIONS_LOADED = 'VAS_ALL_LOADED';
export const VAS_SUBSCRIPTIONS_LOAD_ERROR = 'VAS_ALL_LOAD_ERROR';
export const VAS_DISABLING_STATUS_CHANGE = 'VAS_DISABLING_STATUS_CHANGE';
export const VAS_SET_VAS_ERROR = 'VAS_SET_VAS_ERROR';
export const VAS_GAMERSBASE_URL = 'VAS_GAMERSBASE_URL';
